// extracted by mini-css-extract-plugin
export default {"main":"_7e599bc19c","tit":"a05f561be9","maintitle":"_259c585968","ylw":"bb74d45563","white":"c3a12316ef","mv_title":"_3e5cc170e2","mv_nc":"_46f17f6bc0","mv_in":"_1e783fa34e"};